// extracted by mini-css-extract-plugin
export default {"java":"Java_java__dsiFI","divs":"Java_divs__LKewd"};